import { useMemo } from 'react';

import { Box, Flex, Text } from '@chakra-ui/react';

import { getFormattedCurrency, getVariantTotalPerParticipant } from '../../../../utils/business/prices';
import { COMMON_GAP, ROUNDED_ELEMENT_PROPS } from '../../../../utils/styleUtil';
import VariantLineCommonContent from '../display/VariantLineCommonContent';
import OptionParticipant from '../options/OptionParticipant';
import OptionPrice from '../options/OptionPrice';

const VariantLinePerPerson = ({ variant, loggedUser, isFree, nbAvaSelected, placesAvailable, placesMax, ...props }) => {
  const variantTotal = useMemo(() => getVariantTotalPerParticipant(variant, nbAvaSelected), [JSON.stringify(variant)]);

  return (
    <Box bg="brand.background_main" position="relative" {...ROUNDED_ELEMENT_PROPS} paddingBottom="2rem">
      <Flex wrap="wrap" gap={COMMON_GAP} alignItems="center">
        <OptionParticipant
          fieldValue={variant.participant}
          loggedUser={loggedUser}
          placesAvailable={placesAvailable}
          placesMax={placesMax}
          {...props}
        />

        {!isFree && <OptionPrice variant={variant} {...props} displayInline />}
      </Flex>

      <VariantLineCommonContent loggedUser={loggedUser} variant={variant} {...props} />

      {variantTotal > 0 && (
        <Text position={{ base: undefined, md: 'absolute' }} mt=".7rem" textAlign="right" bottom=".2rem" right=".5rem">
          {getFormattedCurrency(variantTotal)}
        </Text>
      )}
    </Box>
  );
};

export default VariantLinePerPerson;
